function PageLoader() {
    return (
        <div style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            minHeight: '100vh',
            background: '#f8fafc',
            gap: '1.5rem',
        }}>
            <div style={{
                display: 'flex',
                alignItems: 'center',
                gap: '0.75rem',
            }}>
                <div style={{
                    width: '40px',
                    height: '40px',
                    background: 'linear-gradient(135deg, #3b82f6, #1d4ed8)',
                    borderRadius: '10px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    color: 'white',
                    fontWeight: '800',
                    fontSize: '1rem',
                }}>
                    CP
                </div>
                <div>
                    <div style={{ fontWeight: '700', color: '#1e293b', fontSize: '1rem' }}>Career Platform</div>
                    <div style={{ fontSize: '0.72rem', color: '#64748b', textTransform: 'uppercase', letterSpacing: '0.05em' }}>Career AI</div>
                </div>
            </div>

            <div style={{ display: 'flex', gap: '0.5rem' }}>
                {[0, 1, 2].map(i => (
                    <div key={i} style={{
                        width: '10px',
                        height: '10px',
                        borderRadius: '50%',
                        background: '#3b82f6',
                        animation: `bounce 1.2s ease-in-out ${i * 0.2}s infinite`,
                    }} />
                ))}
            </div>

            <p style={{ color: '#94a3b8', fontSize: '0.85rem', margin: 0 }}>
                Starting up, please wait...
            </p>

            <style>{`
                @keyframes bounce {
                    0%, 80%, 100% { transform: scale(0.6); opacity: 0.4; }
                    40% { transform: scale(1); opacity: 1; }
                }
            `}</style>
        </div>
    );
}

export default PageLoader;